import React, { useState, useRef } from "react";
import styled from "styled-components";

export default function Form() {
  const [isAgreed, setIsAgreed] = useState(false);
  const nameEl = useRef(null);
  const emailEl = useRef(null);
  const contentEl = useRef(null);

  function onCheck(e) {
    e.preventDefault();

    const name = nameEl.current;
    const email = emailEl.current;
    const content = contentEl.current;
    const errorClassName = "is-error";

    name.classList.remove(errorClassName);
    email.classList.remove(errorClassName);
    content.classList.remove(errorClassName);

    if (!name.value.length) {
      name.classList.add(errorClassName);
    }
    if (!email.value.length) {
      email.classList.add(errorClassName);
    }
    if (!content.value.length) {
      content.classList.add(errorClassName);
    }

    if (!name.value.length || !email.value.length || !content.value.length) {
      return;
    }

    alert("送信しました！");
  }

  return (
    <StyledForm>
      <div className="inner">
        <form action="">
          <div className="item">
            <label htmlFor="name">お名前（必須）</label>
            <input type="text" id="name" name="" ref={nameEl} />
            <p className="error">お名前が入力されていません</p>
          </div>
          <div className="item">
            <label htmlFor="email">メールアドレス（必須）</label>
            <input type="text" id="email" name="" ref={emailEl} />
            <p className="error">メールアドレスが入力されていません</p>
          </div>
          <div className="item">
            <label htmlFor="content">内容（必須）</label>
            <textarea id="content" name="" ref={contentEl} />
            <p className="error">内容が入力されていません</p>
          </div>
          <div className="item">
            <label>
              <input type="checkbox" onChange={() => setIsAgreed(!isAgreed)} />
              <span>プライバシーポリシーに同意する</span>
            </label>
          </div>
          <div className="action">
            <button
              className="button -primary -large"
              disabled={!isAgreed}
              onClick={(e) => onCheck(e)}
            >
              送信する
            </button>
          </div>
        </form>
      </div>
    </StyledForm>
  );
}

const StyledForm = styled.div`
  form {
    padding: 48px 0 80px;
  }
  .item {
    & + .item {
      margin-top: 24px;
    }
    label {
      display: block;
      margin-bottom: 8px;
    }
    input[type=text],
    textarea {
      &.is-error {
        & + .error {
          display: block;
        }
      }
    }
    .error {
      display: none;
      font-size: 12px;
      color: red;
      margin: 8px 0 0;
    }
  }
  .action {
    margin-top: 40px;
    display: flex;
    justify-content: center;
  }
`;
